import { create } from 'zustand';

interface RiskObjectInputStore {
  // dotnotation of the focussed input field
  focusedInput: string | null;
  setFocusedInput: (input: string | null) => void;
  reset: () => void;
}

/** The store will manage the focused input for risk objects
 * This is used in the document extraction feature to highlight values
 */
const useRiskObjectInputStore = create<RiskObjectInputStore>((set) => ({
  focusedInput: null,
  setFocusedInput: (input) =>
    set((state) => ({
      ...state,
      focusedInput: input,
    })),
  reset: () => set({ focusedInput: null }),
}));

export default useRiskObjectInputStore;
